export const getRadiusInMeters = (lat: number, zoom: number) => {
  const metersPerPx =
    (156543.03392 * Math.cos((lat * Math.PI) / 180)) / Math.pow(2, zoom);

  return (795.327 / 2) * metersPerPx;
};
